import { isDev, isProduction, MIXPANEL_TOKEN } from 'constants/api';

import mixpanelPlugin from '@cuemath/analytics-v2/dist/plugins/mixpanel';

export const isMixpanelEnabled = (isDev || isProduction) && !!MIXPANEL_TOKEN;

export const mixPanelPlugin = mixpanelPlugin({
  token: MIXPANEL_TOKEN,
  trackAllEvents: false,
  batchRequests: false,
});
